import { Badge } from '@wyz/ui';
import * as React from 'react';
import { Trans } from '~/common/context';
import { ITransportItemStatus } from '~/common/types';
import {
  TRANSPORT_ITEM_STATUS_COLOR_LOOKUP,
  TRANSPORT_ITEM_STATUS_LABEL_LOOKUP,
} from '~/common/translators';

type BadgeProps = React.ComponentProps<typeof Badge>;
const StatusBadge: React.FC<{
  status: ITransportItemStatus;
  size?: BadgeProps['size'];
}> = ({ status, size }) => {
  const statusColor = TRANSPORT_ITEM_STATUS_COLOR_LOOKUP[status];
  const statusKey = TRANSPORT_ITEM_STATUS_LABEL_LOOKUP[status];

  return (
    <Badge bg={statusColor ?? 'secondary'} size={size ?? 'xs'} pill>
      {statusKey ? <Trans i18nKey={statusKey} /> : status}
    </Badge>
  );
};

export default StatusBadge;
